import React from "react";

function ListItem({ index, name, points }) {
  return (
    <li className="flex items-center justify-between text-xl font-bold">
      <div className="text-inherit flex items-center gap-[10px]">
        <div className="bg-primary flex h-10 w-10 items-center justify-center rounded-full leading-none">
          {index + 1}
        </div>
        <p className="mb-0 font-semibold leading-none">{name}</p>
      </div>
      <p className="text-primary mb-0 font-semibold leading-none">
        {points} poäng
      </p>
    </li>
  );
}

export default ListItem;
